export default __webpack_public_path__ + "static/media/bus.151c1823.svg";